import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  ReservationEdit,
  Reservations,
  ReservationSequenceEdit,
  ReservationsOverview,
  Rooms,
  RoomsEdit,
  RoomsResponsible,
  RoomsResponsibleEdit,
} from '../pages/CMSPages/index';
import React from 'react';

const RoomsReservationsRoutes = () => (
  <>
    <Route
      path={`${routes.cmsRooms}`}
      element={
        <CMSWrapper permissions={['rooms.index']}>
          <Rooms />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsRoomsEdit}/:id`}
      element={
        <CMSWrapper permissions={['rooms.show']}>
          <RoomsEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsRoomsCreate}
      element={
        <CMSWrapper permissions={['rooms.store']}>
          <RoomsEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsRoomResponsible}
      element={
        <CMSWrapper permissions={['room-responsible.index']}>
          <RoomsResponsible mode={''} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsRoomResponsibleEdit}/:id`}
      element={
        <CMSWrapper permissions={['room-responsible.show']}>
          <RoomsResponsibleEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsRoomResponsibleCreate}
      element={
        <CMSWrapper permissions={['room-responsible.store']}>
          <RoomsResponsibleEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsReservations}
      element={
        <CMSWrapper permissions={['reservations.index']}>
          <Reservations />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsReservationsCreate}
      element={
        <CMSWrapper permissions={['reservations.store']}>
          <ReservationEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsReservationsCreateParams}/:room_id/:date`}
      element={
        <CMSWrapper permissions={['reservations.store']}>
          <ReservationEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsReservationsEdit}/:id`}
      element={
        <CMSWrapper permissions={['reservations.show']}>
          <ReservationEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsReservationSequenceCreate}
      element={
        <CMSWrapper permissions={['reservations-sequence.store']}>
          <ReservationSequenceEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsReservationSequenceEdit}/:id`}
      element={
        <CMSWrapper permissions={['reservations-sequence.show']}>
          <ReservationSequenceEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsReservationOverview}
      element={
        <CMSWrapper>
          <ReservationsOverview />
        </CMSWrapper>
      }
    />
  </>
);

export default RoomsReservationsRoutes;
